import CrioLogo from '@components/NavigationV2/Navbar/CrioLogo/index';
import React from 'react';

export default function CertGenNavigation() {
  return (
    <CrioLogo containerClassName="flex h-14 w-full items-center justify-center bg-v5-green-100 md:h-20" />
  );
}
